/**
 * FDV — Localizador de tiendas (propio, reemplaza Closeby / BSS / Storemapper).
 *
 * Progressive enhancement sobre `blocks/fdv-store-locator.liquid`:
 *   - sin JS: se ven todas las tiendas, el <select> queda oculto.
 *   - con JS: revela el <select>, filtra las tarjetas por estado, actualiza el
 *     conteo y el estado vacío, y sincroniza `?estado=` en la URL (deep-link).
 *
 * Los datos vienen del metaobjeto `fdv_tienda` (horneados server-side en el
 * bloque). Este archivo no hace fetch ni conoce el esquema — solo muestra/oculta
 * nodos por `data-estado`.
 */
if (!customElements.get('fdv-store-locator')) {
  customElements.define(
    'fdv-store-locator',
    class FdvStoreLocator extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-fdv-locator-filter]');
        this.filterWrap = this.querySelector('[data-fdv-locator-filterwrap]');
        this.items = Array.from(this.querySelectorAll('[data-estado]'));
        this.countEl = this.querySelector('[data-fdv-locator-count]');
        this.emptyEl = this.querySelector('[data-fdv-locator-empty]');
        this.listEl = this.querySelector('[data-fdv-locator-list]');

        if (this.select) {
          if (this.filterWrap) this.filterWrap.hidden = false;
          this.select.addEventListener('change', () => this.apply());

          const requested = new URLSearchParams(location.search).get('estado');
          if (
            requested &&
            Array.from(this.select.options).some((o) => o.value === requested)
          ) {
            this.select.value = requested;
          }
        }

        this.apply();
      }

      apply() {
        const value = this.select ? this.select.value : '';
        let visible = 0;

        for (const el of this.items) {
          const match = !value || el.dataset.estado === value;
          el.hidden = !match;
          if (match) visible += 1;
        }

        if (this.countEl) {
          this.countEl.textContent =
            visible === 1 ? '1 tienda' : `${visible} tiendas`;
        }
        if (this.emptyEl) {
          this.emptyEl.hidden = visible !== 0;
        }
        if (this.listEl) {
          this.listEl.hidden = visible === 0;
        }

        if (this.select) {
          const url = new URL(location.href);
          if (value) {
            url.searchParams.set('estado', value);
          } else {
            url.searchParams.delete('estado');
          }
          history.replaceState(null, '', url);
        }
      }
    }
  );
}
